import { StoryDisplayOptions } from '../components/Story';
import { StoryDisplay, StoryWithShoppables } from '../enums';
import { FontComponents } from '../utils/font';

export const STORY_DEFAULT_ANIMATIONS: StoryDisplayOptions['animations'] = [];
export const STORY_DEFAULT_BORDER: Record<
  StoryDisplay,
  StoryDisplayOptions['border']
> = { round: 'solid', square: 'none' };
export const STORY_DEFAULT_BORDER_COLOR: StoryDisplayOptions['borderColor'] =
  'black';
export const STORY_DEFAULT_DISPLAY: StoryDisplayOptions['display'] =
  StoryDisplay.Square;
export const STORY_DEFAULT_FONT: Record<StoryDisplay, FontComponents> = {
  round: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': 'clamp(12px, 9vh, 2rem)',
    'line-height': 'normal',
    'font-family': ["'Inter'", 'sans-serif'],
  },
  square: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': 'clamp(12px, 4vh, 2rem)',
    'line-height': 'normal',
    'font-family': ["'Inter'", 'sans-serif'],
  },
};
export const STORY_DEFAULT_WITH_SHOPPABLES: StoryDisplayOptions['withShoppables'] =
  StoryWithShoppables.Off;
export const STORY_DEFAULT_WITH_PLAY_ICON: StoryDisplayOptions['withPlayIcon'] =
  true;
export const STORY_DEFAULT_WITH_RADIUS: StoryDisplayOptions['withRadius'] =
  true;
export const STORY_DEFAULT_WITH_TITLE: StoryDisplayOptions['withTitle'] = true;

export const STORY_LINE_CLAMP = 2;
export const STORY_ROUND_PULSE_SIZE = 7;
export const STORY_ROUND_ASPECT_RATIO = {
  WITH_TITLE: '12/16',
  WITHOUT_TITLE: '1',
} as const;
export const STORY_SQUARE_RADIUS = 'clamp(6px, 5vh, 24px)';
